module.exports = __webpack_public_path__ + "img/practitioner-sign.fad79df7.svg";